import { render, staticRenderFns } from "./StudentChecks.vue?vue&type=template&id=bf7692b4"
import script from "./StudentChecks.vue?vue&type=script&lang=ts"
export * from "./StudentChecks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports